<template src="./PersonalsList.template.html"></template>

<script setup>
import { onMounted, onUnmounted, watch, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { usePersonals } from '@/composables/usePersonals'
import { Plus } from 'lucide-vue-next'
import { useRouter } from 'vue-router'

// Components
import PageHeader from '../components/ui/PageHeader.vue'
import LayoutMain from '../components/ui/LayoutMain.vue'
import Button from '../components/ui/Button.vue'
import Card from '../components/ui/Card.vue'
import Text from '../components/ui/Text.vue'
import LoadingSpinner from '../components/ui/LoadingSpinner.vue'
import ErrorDisplay from '../components/ui/ErrorDisplay.vue'
import PersonalAdCard from '../components/PersonalAdCard.vue'
import PersonalsActionBar from '../components/PersonalsActionBar.vue'
import LoadingSkeleton from '../components/LoadingSkeleton.vue'
import PersonalsTopBar from '../components/personals/PersonalsTopBar.vue'

// Composables
const { t } = useI18n()
const router = useRouter()
const {
  filteredAds,
  hasAds,
  isLoading,
  error,
  pagination,
  loadAds,
  loadMore,
  navigateToAd,
  navigateToCreate,
  clearError
} = usePersonals()

// Local state
const isLoadingMore = ref(false)

// Methods
async function handleLoadMore() {
  if (isLoadingMore.value || !pagination.value.hasMore) return

  isLoadingMore.value = true
  try {
    await loadMore()
  } finally {
    isLoadingMore.value = false
  }
}

function handleAdClick(ad) {
  navigateToAd(ad.id)
}

function handleReplyClick(ad) {
  navigateToAd(ad.id)
}
function handleViewReplies(ad) {
  // when card emits view-replies (own ad), go to ad-replies route
  router.push({ name: 'ad-replies', params: { id: ad.id } })
}


function handleCreateFromActionBar() {
  navigateToCreate()
}

function handleMyAdsFromActionBar() {
  router.push({ name: 'my-personals' })
}

// Lifecycle
onMounted(async () => {
  await loadAds()
})

// Cleanup
onUnmounted(() => {
  clearError()
})

// Watch for errors and auto-clear them
watch(error, newError => {
  if (newError) {
    setTimeout(() => {
      clearError()
    }, 5000)
  }
})
</script>

<style scoped>
.personals-list {
  min-height: 100vh;
}

.ads-grid {
  display: grid;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .ads-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .ads-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.load-more-container {
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}

.empty-state {
  text-align: center;
  padding: 3rem 1rem;
}
</style>
